export default __webpack_public_path__ + "static/media/wasac.4ad0d407.svg";